import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useModalRouter from 'hooks/useModalRouter';

import { PURCHASE_ORDER } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const PurchaseOrders = () => {
	const { showModal } = useModalRouter();
	const columns = useMemo(
		() => [
			{ Header: 'purchaseOrderNumber', accessor: 'id', filterType: FilterType.number },
			{
				Header: 'refNumber',
				accessor: 'RefNumber',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'vendor',
				accessor: 'Vendor',
				filterType: FilterType.multiSelection,
				width: 100
			},
			{
				Header: 'requestedBy',
				accessor: 'requestedByUsername',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'shippingTerm',
				accessor: 'shippingTerm',
				filterType: FilterType.string
			},
			{
				Header: 'date',
				accessor: 'date',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				showOnMobile: true,
				renderCell: ListComponents.STATUS
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);
	return (
		<div>
			<PageHeader
				title="purchaseOrders"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/inventory-icon.json.gz">
				<Authorization path="/modal/purchase-order-form">
					<Button
						icon={faPlus}
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						label="addOrder"
						onClick={() => showModal('purchase-order-form', { mode: 'add' })}
						variant="blue"
						className="addButton"
					/>
				</Authorization>
			</PageHeader>
			<DynamicList
				id={DYNAMICLISTS.PURCHASE_ORDERS}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={PURCHASE_ORDER.GET_PURCHASE_ORDERS}
				actionObjectType={ACTION_OBJECT_TYPES.PURCHASE_ORDER}
				exportName="purchaseOrders"
			/>
		</div>
	);
};

export default PurchaseOrders;
